import { tableTbody } from '@mage-ui/styled-system/recipes';
import { Table } from '@mantine/core';

export const TableTbody = ({ children }) => {
  return <Table.Tbody className={tableTbody()}>{children}</Table.Tbody>;
};
